

































import { Component, Prop, Mixins } from "vue-property-decorator";
import Context from "@/mixins/context";

@Component
export default class StatView extends Mixins(Context) {
  // Props
  @Prop({ default: 0 })
  public value!: any;

  @Prop({ default: null })
  public label!: string;

  @Prop({ default: "div" })
  public component!: string;

  @Prop({ default: null })
  public to!: any;

  @Prop({ default: true })
  public contentAvailable!: boolean;

  @Prop({ default: null })
  public tooltipMessage!: string;

  @Prop({ default: null })
  public tooltipMessageSubheader!: string;
}
